Additional fields to filter which events are to be replayed.

This is an alternative to the `eventIds` argument, and allows replaying events within a designated time range.
`eventIds` and `filter` cannot be specified in the same mutation.
